<template>
  <div class="page-body page-vipRights_intro clearfix">
    <div class="side">
      <dl class="side-nav">
        <dt>特权介绍</dt>
        <dd>
          <a
            v-for="(item, i) in tabs"
            :key="i"
            href="javascript:;"
            :class="{ cur: isCur(item) }"
            @click="$router.push(item.path)"
            >{{ item.title }}</a
          >
        </dd>
      </dl>
    </div>
    <nuxt-child />
  </div>
</template>

<script>
export default {
  layout: 'vip-rights',
  data() {
    return {
      tabs: [
        { title: '每月优惠券', path: '/vip-rights/intro/counpon' },
        { title: '首充特权', path: '/vip-rights/intro/first-pay' },
        { title: 'VIP礼包特权', path: '/vip-rights/intro/vip-package' },
        { title: '更多特权', path: '/vip-rights/intro/more' }
      ]
    }
  },
  methods: {
    isCur({ path }) {
      const { name } = this.$store.state.route
      if (name.includes('vip-rights-intro')) {
        const last = name.split('vip-rights-intro-')[1]
        return path.includes(last)
      }
      return false
    }
  }
}
</script>
